import {
  Avatar,
  Box,
  Card,
  CardContent,
  Drawer,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";

import React from "react";
import {
  MAIN_THEME_COLOR,
  SECONDARY_THEME_COLOR,
} from "../../providers/theme/colors/colors";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./style.css";
import {
  ChevronRightRounded,
  Close,
  KeyboardArrowDownOutlined,
  Menu,
} from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";

const drawerWidth = 240;

export default function Navbar() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isCompactNav = useMediaQuery(theme.breakpoints.down("lg"));
  const [open, setOpen] = React.useState(false);
  const { pathname } = useLocation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  let navItems: {
    name: string;
    path: string;
    scrollTo?: string;
    link?: string;
    dropdownItems?: {
      name: string;
      path: string;
      innerLevelDropdown?: { name: string; path: string }[];
    }[];
  }[] = [
    { name: "Home", path: "/" },
    {
      name: "About Us",
      path: "",
      dropdownItems: [
        { name: "SAMMITRA", path: "/about" },
        { name: "ICYM, YCS and YSM DEXCO's", path: "/dexco" },
      ],
    },

    // {
    //   name: "Deanery & Parish",
    //   path: "",
    //   dropdownItems: [
    //     {
    //       name: "Kundapur Deanery",
    //       path: "",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Kallianpur Deanery",
    //       path: "/profile/edit",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Udupi Deanery",
    //       path: "/profile/edit",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Karkol Deanery",
    //       path: "/profile/edit",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Shirva Deanery",
    //       path: "",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //   ],
    // },
    { name: "News", path: "/news" },
    { name: "Yuvagaaz", path: "/yuvagaaz" },
    {
      name: "Events Calendar",
      path: "/eventsCalendar",
      // link: "https://eventbb.bookbetter.app/getCalendar/66ac820589dbe9e46d1afb74",
    },
    // {
    //   name: "Redon",
    //   path: "/yuvadabazo",
    //   dropdownItems: [
    //     {
    //       name: "Kundapur Deanery",
    //       path: "",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Kallianpur Deanery",
    //       path: "/profile/edit",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Udupi Deanery",
    //       path: "/profile/edit",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Karkol Deanery",
    //       path: "/profile/edit",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //     {
    //       name: "Shirva Deanery",
    //       path: "",
    //       innerLevelDropdown: [
    //         { name: "Deanery Director & Commitee", path: "/parishes" },
    //         { name: "Parishes", path: "/parishes" },
    //       ],
    //     },
    //   ],
    // },
    // { name: "Yuvadabazo 2.0", path: "/yuvadabazo" },
    { name: "Contact us", path: "/contactus" },
    {
      name: "More",
      path: "",
      dropdownItems: [
        { name: "Gallery", path: "/gallery" },
        { name: "YouCat", path: "/youcat" },
        { name: "REDON", path: "/redon" },
        { name: "Yuva Dabazo", path: "/yuvadabazo" },
      ],
    },
  ];

  const mobileNavItems = navItems.flatMap((item) => {
    if (!item.dropdownItems?.length) {
      return [item];
    }

    return item.dropdownItems.map((dropdownItem) => ({
      name: dropdownItem.name,
      path: dropdownItem.path,
      link: undefined,
    }));
  });

  const isItemActive = (item: (typeof navItems)[number]) => {
    if (item.path && pathname === item.path) {
      return true;
    }

    if (item.path === "/news" && pathname.startsWith("/news")) {
      return true;
    }

    return Boolean(
      item.dropdownItems?.some(
        (dropdownItem) => pathname === dropdownItem.path,
      ),
    );
  };

  const handlePopoverOpen = (
    event: React.MouseEvent<HTMLElement>,
    id: string,
  ) => {
    var x = document.getElementById(id);
    if (x) {
      x.style.display = "block";
    }
  };

  const handlePopoverClose = (id: string) => {
    var x = document.getElementById(id);
    if (x) {
      x.style.display = "none";
    }
  };

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
  }));

  return (
    <Grid
      container
      sx={{
        mt: 0,
        pt: { xs: 0.5, md: 1.25 },
        px: { xs: 1, sm: 3, md: 4 },
        pb: 0,
        alignItems: "center",
        rowGap: { xs: 0.5, md: 0 },
      }}
    >
      <Grid item md={4} lg={4} sm={10} xs={10}>
        <Box display={"flex"} alignItems={"center"} minWidth={0}>
          <Box
            sx={{
              mx: { xs: 0.75, sm: 2, md: 3 },
              p: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Avatar
              alt="SAMMITRA logo"
              src="/images/icons/sammitra_logo.png"
              sx={{
                height: { xs: 52, sm: 60, md: 72 },
                width: { xs: 52, sm: 60, md: 72 },
              }}
            />
          </Box>
          <Box minWidth={0}>
            <Typography
              variant="h6"
              fontWeight={"600"}
              sx={{
                fontSize: { xs: "0.95rem", sm: "1.05rem", md: "1.2rem" },
                lineHeight: 1.25,
              }}
            >
              SAMMITRA, Youth Commission Diocese of Udupi
            </Typography>
          </Box>
        </Box>
      </Grid>
      {!isCompactNav && (
        <Grid
          display={"flex"}
          item
          md={8}
          lg={8}
          sm={12}
          justifyContent={"flex-end"}
          alignItems={"center"}
          flexWrap={"wrap"}
          rowGap={1}
        >
          {navItems?.map((item) => {
            return (
              <Box
                ml={{ md: 3, lg: 5 }}
                position="relative"
                onMouseLeave={() => handlePopoverClose(item?.name)}
              >
                <Box
                  onMouseEnter={(e) => {
                    handlePopoverOpen(e, item?.name);
                    let x = document.getElementById(item?.name + "underline");
                    if (x) {
                      x.style.display = "block";
                    }
                  }}
                  onMouseLeave={(e) => {
                    let x = document.getElementById(item?.name + "underline");
                    if (x) {
                      x.style.display = "none";
                    }
                  }}
                  onClick={(e) => {
                    if (item?.dropdownItems?.length) {
                      return;
                    }

                    if (item?.scrollTo) {
                      const element = document.getElementById(item?.scrollTo);
                      element?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    } else if (item?.link) {
                      window.open(item?.link, "_blank", "noopener,noreferrer");
                    } else if (item?.path) {
                      navigate(item.path);
                      window.scrollTo(0, 0);
                    }
                  }}
                  sx={{ cursor: "pointer" }}
                >
                  <Typography
                    display={"flex"}
                    style={{
                      color: isItemActive(item) ? MAIN_THEME_COLOR : "#1B001B",
                      fontWeight: isItemActive(item) ? "600" : "500",
                    }}
                    textAlign="center"
                  >
                    {item?.name}

                    {item?.dropdownItems && (
                      <KeyboardArrowDownOutlined
                        fontSize="small"
                        sx={{ mt: 0.5 }}
                      />
                    )}
                  </Typography>
                  <Box
                    display={isItemActive(item) ? "block" : "none"}
                    id={item?.name + "underline"}
                    sx={{
                      width: { md: "20px", lg: "28px" },
                      height: "4px",
                      backgroundColor: "primary.main",
                      margin: "auto",
                      mt: 0.5,
                      borderRadius: "999px",
                    }}
                  ></Box>
                </Box>
                {item?.dropdownItems && (
                  <Box
                    className="animated-dropdown-container"
                    display={"none"}
                    id={item?.name}
                    zIndex={999}
                    sx={{
                      px: 1,
                      flexDirection: "column",
                      position: "absolute",
                      top: 34,
                      left: item.name === "About Us" ? -36 : -100,
                      minWidth: item.name === "About Us" ? 320 : 250,
                      transition: "opacity .5s ease-out",
                    }}
                    width="100%"
                  >
                    <Box
                      id={item?.name}
                      sx={{
                        transform: "translateX(400%)",
                        width: "0",
                        height: "0",
                        borderBottom: "15px solid #ffffff",
                        borderLeft: "25px solid transparent",
                        borderRight: "15px solid transparent",
                      }}
                    />
                    {item?.dropdownItems.length !== 0 && (
                      <Card
                        elevation={10}
                        sx={{
                          display: "flex",
                          flex: 1,
                          px: item.name === "About Us" ? 1.25 : 2,
                          flexDirection: "column",
                          py: item.name === "About Us" ? 1.25 : 1,
                          borderRadius: 3,
                          background:
                            item.name === "About Us"
                              ? "linear-gradient(180deg, rgba(247,251,255,0.98) 0%, rgba(255,255,255,1) 100%)"
                              : "#ffffff",
                        }}
                      >
                        {item?.dropdownItems?.map((dropDownItem) => {
                          const isAboutDropdown = item.name === "About Us";
                          return (
                            <Box
                              key={dropDownItem.name}
                              display="flex"
                              width={"100%"}
                              sx={{
                                position: "relative",
                              }}
                              onMouseEnter={(e) => {
                                let x = document.getElementById(
                                  dropDownItem?.name + "innerDropDown",
                                );
                                if (x) {
                                  x.style.display = "block";
                                }
                              }}
                              onMouseLeave={(e) => {
                                let x = document.getElementById(
                                  dropDownItem?.name + "innerDropDown",
                                );
                                if (x) {
                                  x.style.display = "none";
                                }
                              }}
                            >
                              <Link
                                to={dropDownItem?.path}
                                style={{
                                  textDecoration: "none",
                                  width: "100%",
                                }}
                                onClick={() => window.scrollTo(0, 0)}
                              >
                                {isAboutDropdown ? (
                                  <Card
                                    elevation={0}
                                    sx={{
                                      mb: 1,
                                      borderRadius: 3,
                                      border: `1px solid ${SECONDARY_THEME_COLOR}55`,
                                      boxShadow:
                                        "0 14px 32px rgba(9, 51, 84, 0.09)",
                                      background:
                                        "linear-gradient(180deg, rgba(247,251,255,0.98) 0%, rgba(255,255,255,1) 100%)",
                                      transition:
                                        "transform 0.2s ease, box-shadow 0.2s ease",
                                      ":hover": {
                                        transform: "translateY(-2px)",
                                        boxShadow:
                                          "0 18px 36px rgba(9, 51, 84, 0.14)",
                                      },
                                    }}
                                  >
                                    <CardContent
                                      sx={{
                                        p: 2.25,
                                        "&:last-child": { pb: 2.25 },
                                      }}
                                    >
                                      <Typography
                                        variant="subtitle1"
                                        fontWeight={700}
                                        color={MAIN_THEME_COLOR}
                                      >
                                        {dropDownItem?.name}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        mt={0.75}
                                        sx={{ lineHeight: 1.6 }}
                                      >
                                        {dropDownItem?.path === "/about"
                                          ? "Youth Commission leadership, information, and deanery directors."
                                          : "ICYM, YCS & YCS DEXCO Information."}
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                ) : (
                                  <Typography
                                    variant="body2"
                                    pl={2}
                                    color={"#1B001B"}
                                    mt={1}
                                    mb={1}
                                    sx={{
                                      ":hover": {
                                        borderLeft: `3px solid ${SECONDARY_THEME_COLOR}`,
                                        backgroundColor: "#F1F2F4",
                                      },
                                    }}
                                  >
                                    {dropDownItem?.name}
                                  </Typography>
                                )}
                              </Link>

                              <Box
                                display="none"
                                id={dropDownItem?.name + "innerDropDown"}
                                sx={{
                                  px: 2,
                                  flexDirection: "column",
                                  position: "absolute",
                                  top: 30,
                                  left: 220,
                                  minWidth: 250,
                                  transition: "opacity .5s ease-out",
                                }}
                              >
                                <Card
                                  elevation={10}
                                  sx={{
                                    display: "flex",
                                    px: 1,
                                    flexDirection: "column",
                                    py: 1,
                                  }}
                                >
                                  {dropDownItem?.innerLevelDropdown?.map(
                                    (item) => {
                                      return (
                                        <Link
                                          to={item?.path}
                                          style={{
                                            textDecoration: "none",
                                            color: "inherit",
                                          }}
                                          onClick={() => window.scrollTo(0, 0)}
                                        >
                                          <Typography
                                            variant="body2"
                                            my={1}
                                            pl={2}
                                            sx={{
                                              cursor: "pointer",
                                              ":hover": {
                                                borderLeft: `3px solid ${SECONDARY_THEME_COLOR}`,
                                              },
                                            }}
                                          >
                                            {item?.name}
                                          </Typography>
                                        </Link>
                                      );
                                    },
                                  )}
                                </Card>
                              </Box>
                            </Box>
                          );
                        })}
                      </Card>
                    )}
                  </Box>
                )}
              </Box>
            );
          })}
        </Grid>
      )}

      {isCompactNav && (
        <Grid
          display={"flex"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          item
          sm={2}
          xs={2}
        >
          <IconButton
            color="primary"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerOpen}
            sx={{ ...(open && { display: "none" }), p: 0, m: 0 }}
          >
            <Menu />
          </IconButton>
        </Grid>
      )}
      <Grid item xs={12}>
        <Box
          sx={{
            mt: { xs: 0.75, md: 1 },
            borderBottom: `1px solid ${MAIN_THEME_COLOR}33`,
            width: "100%",
          }}
        />
      </Grid>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
          },
        }}
        variant="persistent"
        anchor="right"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? <Close /> : <Close />}
          </IconButton>
        </DrawerHeader>
        <Box display={"flex"} flexDirection={"column"}>
          {mobileNavItems.map((item, index) => (
            <Box
              key={item.name + index}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              m={1.25}
            >
              <Box sx={{ borderBottom: `1px solid ${MAIN_THEME_COLOR}` }}>
                <Link
                  to={item?.path}
                  style={{
                    textDecoration: "none",
                    width: "fit-content",
                  }}
                  onClick={() => {
                    setOpen(false);
                    window.scrollTo(0, 0);
                    if (item?.link) {
                      window.open(
                        "https://eventbb.bookbetter.app/getCalendar/66ac820589dbe9e46d1afb74",
                        "_blank",
                        "noopener,noreferrer",
                      );
                    }
                  }}
                >
                  <Typography color={"#1B001B"}>{item?.name}</Typography>
                </Link>
              </Box>
              <ChevronRightRounded onClick={() => navigate(item?.path)} />
            </Box>
          ))}
        </Box>
      </Drawer>
    </Grid>
  );
}
